<template>

  <v-autocomplete v-model="categoryID"
                  label="Category"
                  :placeholder="placeholder"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"></v-autocomplete>

</template>

<script>

export default {
  name: 'CategorySelector',
  props: ['federationID', 'currentCategoryID'],
  data () {
    return {
      loading: false,
      categories: [],
      categoryID: ''
    }
  },
  mounted () {
    if (this.federationID) {
      this.loadCategories()
    }

    if (this.currentCategoryID) {
      this.categoryID = this.currentCategoryID
    }
  },
  methods: {
    loadCategories () {
      if (!this.currentCategoryID) {
        this.$emit('categorySelected', '')
      }

      if (this.federationID) {
        this.loading = true
        this.$store.dispatch('getFederationCategories', this.federationID)
          .then(resp => {
            this.categories = resp
            this.loading = false
          })
          .catch(() => {
            console.error('Error loading categories')
            this.loading = false
          })
      } else {
        this.categoryID = ''
        this.categories = []
      }
    }
  },
  computed: {
    isDisabled () {
      return this.categories.length === 0
    },
    placeholder () {
      return this.isDisabled ? 'Please select a federation first' : 'Category'
    }
  },
  watch: {
    'federationID' () {
      this.loadCategories()
    },
    'categoryID' () {
      this.$emit('categorySelected', this.categoryID || '')
    },
    'currentCategoryID' () {
      if (this.currentCategoryID) {
        this.categoryID = this.currentCategoryID
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/CategorySelector.vue